<template>
    <v-container fluid class="invoice_container container-full-bg-white">
        <v-dialog v-model="screen_data.loading" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Cargando Empresa</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-3">
                    <v-progress-circular indeterminate class="mr-5" color="primary"></v-progress-circular>
                    <span class="text-subtitle-1">Se está buscando la empresa solicitada.</span>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.show_found_popup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Empresa Encontrada</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-3">
                    <span class="text-subtitle-1">Se ha encontrado la empresa solicitada.</span>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="goToCompany()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="screen_data.show_not_found_popup" max-width="660">
            <v-card class="rounded-lg">
                <v-card-title>
                    <span class="primary__blue">Empresa No Encontrada</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="mt-3">
                    <span class="text-subtitle-1">No se ha encontrado la empresa solicitada, se redirigirá a la pantalla de creación.</span>
                </v-card-text>
                <v-card-actions class="acction_btns">
                    <v-spacer></v-spacer>
                    <v-btn color="primary_blue" class="white--text action__btn" @click="createCompany()">
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LoadCompanyScreen } from '../application/LoadCompany';
import { Company } from '../domain/Company';
import { ApiCompanyRepository } from './ApiCompanyRepository';
import { VueLoadCompanyScreenData } from './VueLoadCompanyScreenData';

export default {
    name: 'LoadCompany',
    props: {
        companydb_type: {
            type: String,
            required: true,
        },
        code: {
            type: String,
            required: true,
        }
    },
    data() {
        const company_repo = new ApiCompanyRepository()
        const screen_data = new VueLoadCompanyScreenData()
        const screen = new LoadCompanyScreen(company_repo, screen_data)
        return {
            screen,
            screen_data
        }
    },
    mounted() {
        this.screen.getCompany(this.userData.id, this.code, this.companydb_type)
    },
    methods: {
        ...mapActions([
            'resetCurrentCompany',
        ]),
        async goToCompany() {
            await this.resetCurrentCompany({new_company: this.screen_data.company})
            window.location.href = '/' + this.screen_data.company.id + '/documents';
        },
        createCompany() {
            const params = new URLSearchParams({
                companydb_type: this.companydb_type,
                code: this.code
            });

            // Add optional num_digits if present in URL
            const urlParams = new URLSearchParams(window.location.search);
            const num_digits = urlParams.get('num_digits');
            if (num_digits) {
                params.append('num_digits', num_digits);
            }

            window.location.href = `/create-connector?${params.toString()}`;
        }
    },
    computed: {
        ...mapGetters({ 
            userData: 'me/userData',
        }),
    }

}
</script>

<style scoped>
    .primary__blue {
        color: var(--v-primary_blue-base);
    }
</style>